import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#0a0a0a] border-t border-gold/[0.15]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Left side - Copyright */}
          <p className="text-warm-white/40 text-xs">
            © 2026 Monday Morning Learning Podcasts · Sai Acuity · Hyderabad, India
          </p>
          
          {/* Right side - Tagline */}
          <p className="font-playfair text-gold italic text-sm">
            Where Curiosity Meets Career.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
